var React = require('react');

function CurlyArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#32E2B9","strokeLinecap":"round","strokeWidth":"4"},[React.createElement("path",{"d":"M62.918 2c8.686 24.29 5.206 45.362-10.44 63.216-23.47 26.782-56.536 16.54-49.52-9.674 7.015-26.213 62.821-3.25 61.39 50.106","key":0}),React.createElement("path",{"strokeLinejoin":"round","d":"M54.28 97.844l10.67 11.136 8.498-13.113","key":1})]));
}

CurlyArrowDown.defaultProps = {"width":"76","height":"111","viewBox":"0 0 76 111"};

module.exports = CurlyArrowDown;

CurlyArrowDown.default = CurlyArrowDown;
